module.exports = __webpack_public_path__ + "files/16caf4febcb16807924d370895759670.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags.png
// module id = 591
// module chunks = 59